var Backbone = require('backbone')
  , _ = require('underscore')
  , tmpl = require('./tmpl.handlebars')
  , enableDialog = require('mobile/ui/enableDialog')
  , formUtils = require('@173js/ui/form')
  , ValidateForm = require('widgets/ValidateForm')
  , ued = window.ued || {}
  , openAlert = require('mobile/ui/openAlert')
  , successTmpl = require('./success.handlebars')

var View = Backbone.View.extend({
  events: {
    'submit form': 'formSubmitted'
  }
, initialize: function(options) {
    options = options || {}
    this.userInfo = options.userInfo || {}
    this.triggerBtn = options.triggerBtn || {}
  }
, ajaxSubmitForm: function(dict) {
    var ued = window.ued || {}
      , gameCode = ued.gameCode
      , form = this.form
      , ERROR = '0'
      , ERROR_MESSAGE = '网络发生了错误'

    formUtils.readonlyForm(form)

    return $.ajax({
      type: 'POST',
      url: '/track-updateUserInfo.html',
      dataType:'json',
      data: dict
    }).always(function() {
      formUtils.resumeForm(form)
    }).done(_.bind(function(resp) {
      if (resp.status !== ERROR) {
        this.trigger('close')
        
        // 根据按钮文本类型显示不同的成功文本
        var btnText = '已预定';
        var alertTitle = '预订成功';
        
        // 如果是关注游戏按钮
        if (this.triggerBtn.hasClass('btn-follow-current-game') || this.triggerBtn.text().indexOf('关注') !== -1) {
          btnText = '已关注';
          alertTitle = '关注成功';
        }
        
        this.triggerBtn.addClass('disable')
            .removeClass('btn-engage-current-game')
            .text(btnText)
        return openAlert({
          html: successTmpl({title: alertTitle})
        , title: alertTitle
        })
      }

      this.renderFieldErrors(
        _.map([{ message: resp.msg || ERROR_MESSAGE }])
      )
    }, this))
    .fail(_.bind(function() {
      this.renderFieldErrors(
        _.map([{ message: ERROR_MESSAGE }])
      )
    }, this))
  }
, formSubmitted: function(e) {
    e.preventDefault()
    var dict = formUtils.toDict(this.$('form'))
      , HIDE_ERRORS = []

    this.renderFieldErrors(HIDE_ERRORS)

    if (!this.validateForm.validate()) {
      this.renderFieldErrors(this.validateForm.fieldErrors)
      return
    }

    this.ajaxSubmitForm(dict)
  }
, fetchMemberInfo: function() {
    return $.getJSON('/game-getMemberInfo.html')
  }
, render: function() {
    this.$el.html(tmpl(this.userInfo))

    this.form = this.$('form')
    this.validateForm = new ValidateForm({
      form: this.form
    })

    return this
  }
, renderFieldErrors: function(fieldErrors) {
    // TODO: DRY
    var errorBlock = this.$('.errors-block')
    if (!fieldErrors || !fieldErrors.length) {
      errorBlock.hide()
      return
    }

    errorBlock.empty()

    _.each(fieldErrors, function(x) {
      if (!x.message) { return }
      errorBlock.append('<li>' + x.message + '</li>')
    })

    errorBlock.show()
  }
})

module.exports = enableDialog(View)
